import { z } from 'zod';

export type TIncident = {
  id: string;
  status: string;
  number: string;
  request: string;
  requests: string;
  action: string;
  attachments: string;
  caller: {
    id: string;
    dynamicName: string;
    email: string;
    phoneNumber: string;
    mobileNumber: string;
    branch: {
      id: string;
      name: string;
      clientReferenceNumber: string;
      timeZone: string;
      extraA: string | null;
      extraB: string | null;
    };
    department: {
      id: string;
      name: string;
    };
    budgetHolder: {
      id: string;
      name: string;
    };
  };
  callerBranch: {
    id: string;
    name: string;
    clientReferenceNumber: string;
    timeZone: string;
    extraA: string | null;
    extraB: string | null;
  };
  callerLocation: string | null;
  branchExtraFieldA: string | null;
  branchExtraFieldB: string | null;
  briefDescription: string;
  externalNumber: string;
  category: {
    id: string;
    name: string;
  };
  subcategory: {
    id: string;
    name: string;
  };
  callType: {
    id: string;
    name: string;
  };
  entryType: {
    id: string;
    name: string;
  };
  object: string | null;
  asset: string | null;
  branch: string | null;
  location: string | null;
  impact: {
    id: string;
    name: string;
  };
  urgency: {
    id: string;
    name: string;
  };
  priority: {
    id: string;
    name: string;
  };
  duration: {
    id: string;
    name: string;
  };
  actualDuration: number;
  targetDate: string;
  sla: string | null;
  onHold: boolean;
  onHoldDate: string | null;
  onHoldDuration: number;
  feedbackMessage: string | null;
  feedbackRating: string | null;
  operator: {
    id: string;
    status: string;
    name: string;
  };
  operatorGroup: {
    id: string;
    name: string;
  };
  supplier: string | null;
  processingStatus: {
    id: string;
    name: string;
  };
  responded: boolean;
  responseDate: string | null;
  completed: boolean;
  completedDate: string | null;
  closed: boolean;
  closedDate: string | null;
  closureCode: string | null;
  timeSpent: number;
  timeSpentFirstLine: number;
  timeSpentSecondLine: number;
  timeSpentPartial: number;
  timeSpentLinkedPartials: number;
  timeSpentSecondLineAndPartials: number;
  itemCosts: number;
  objectCosts: number;
  costs: number;
  escalationStatus: string | null;
  escalationReason: string | null;
  escalationOperator: string | null;
  callDate: string;
  creator: string | null;
  creationDate: string;
  modifier: string | null;
  modificationDate: string;
  majorCall: boolean;
  majorCallObject: string | null;
  publishToSsd: boolean;
  monitored: boolean;
  expectedTimeSpent: number;
  archivingReason: string | null;
  mainIncident: string | null;
  optionalFields1: Record<string, unknown>;
  optionalFields2: Record<string, unknown>;
  externalLinks: string[];
  partialIncidents: string[];
  urls: { ssp?: string; operator?: string };
};

export const TopdeskSettingsSchema = z.object({
  selectedBlockId: z.string().nullable(),
});

export const TopdeskSettingsResponseSchema = z.object({
  selectedBlockId: z.string().nullable().optional(),
});

export type TTopdeskSettings = z.infer<typeof TopdeskSettingsSchema>;

export const KnowledgeArticleSchema = z.object({
  id: z.string(),
  number: z.string(),
  translation: z.object({
    language: z.string(),
    content: z.object({
      title: z.string(),
      description: z.string(),
      content: z.string(),
      commentsForOperators: z.string(),
    }),
  }),
  status: z.object({
    id: z.string(),
    name: z.string(),
  }),
  creationDate: z.string(),
  modificationDate: z.string(),
  urls: z.object({
    ssp: z.string(),
    operator: z.string(),
  }),
});

export type TKnowledgeArticle = z.infer<typeof KnowledgeArticleSchema>;
